module.exports = __webpack_public_path__ + "img/portrait-052.0c82eb8d.jpg";